const state = {
  // Todo show filter (used to show "save filter" button, should be a computed return true/false derived from the active filter value
  showFilter: false,
  saveFilter: [],
  checkedFilters: [],
  activeFilter: {
    searchText: '',
    searchCode: '',
    searchStatut: [],
    searchType: [],
    searchWilaya: [],
    searchAnnonceur: [],
    searchSecteur: [],
    datePublication: {
      type: null,
      start: null,
      end: null
    },
    dateEcheance: {
      type: null,
      start: null,
      end: null
    }
  },
  searchFilter: {
    searchText: '',
    searchCode: '',
    searchStatut: [],
    searchType: [],
    searchWilaya: [],
    searchAnnonceur: [],
    searchSecteur: [],
    datePublication: {
      type: null,
      start: null,
      end: null
    },
    dateEcheance: {
      type: null,
      start: null,
      end: null
    }
  },
  addButtonFilter: false,
  chargementTable: false,
  initRechercheAo: false
}

const mutations = {
  SET_FILTER: (state, filter) => {
    state.showFilter = filter
  },
  SET_LOAD_TABLE: (state, filter) => {
    state.chargementTable = filter
  },
  SET_SAVE_FILTER: (state, filter) => {
    state.saveFilter.push(filter)
  },
  SET_DELETE_FILTER: (state, filter) => {
    state.saveFilter = filter
  },
  SET_UPDATE_CHECKED_FILTER: (state, filter) => {
    state.checkedFilters = filter
  },
  SET_DELETE_CHECKED_FILTER: (state, filter) => {
    state.checkedFilters = []
  },
  SET_BUTTON_FILTER: (state, value) => {
    state.addButtonFilter = value
  },
  UNCHECK_ALL_FILTERS: (state) => {
    state.saveFilter.filter((filter) => filter.checked === true).forEach((filter) => {
      filter.checked = false
    })
  },
  CHECK_UNCHECK_FILTER: (state, filter) => {
    if (!filter.checked) {
      state.saveFilter.filter((filter) => filter.checked === true).forEach((filter) => {
        filter.checked = false
      })
      state.searchFilter = JSON.parse(JSON.stringify(Object.assign(state.searchFilter, filter)))
      // state.activeFilter = JSON.parse(JSON.stringify(Object.assign(state.searchFilter, filter)))
      delete state.searchFilter.nom
      delete state.searchFilter.checked
      delete state.searchFilter.id
    } else {
      state.searchFilter = JSON.parse(JSON.stringify(Object.assign(state.searchFilter, {
        searchText: '',
        searchCode: '',
        searchStatut: [],
        searchType: [],
        searchWilaya: [],
        searchAnnonceur: [],
        searchSecteur: [],
        datePublication: {
          type: null,
          start: null,
          end: null
        },
        dateEcheance: {
          type: null,
          start: null,
          end: null
        }
      })))
      delete state.searchFilter.nom
      delete state.searchFilter.checked
      delete state.searchFilter.id
      // do something
    }
    filter.checked = !filter.checked
  },
  UPDATE_ACTIVE_FILTER: (state, filter) => {
    const cleanFilter = Object.assign({}, filter)
    delete cleanFilter.nom
    delete cleanFilter.checked
    delete cleanFilter.id
    state.activeFilter = Object.assign(state.activeFilter, cleanFilter)
  },
  UPDATE_SEARCH_FILTER: (state, filter) => {
    state.searchFilter = Object.assign(state.searchFilter, filter)
  },
  DELETE_SAVED_FILTER: (state, index) => {
    state.saveFilter.splice(index, 1)
  },
  SHOULD_CHECK_FILTER: (state, index) => {
    state.saveFilter[index].checked = true
  },
  SHOULD_UNCHECK_FILTER: (state, index) => {
    state.saveFilter[index].checked = false
  },
  SET_INIT_RECHERCHE_AO: (state, data) => {
    state.initRechercheAo = data
  }
}

const actions = {
  setFilter (store, value) {
    store.commit('SET_FILTER', value)
  },
  setLoadTable (store, value) {
    store.commit('SET_LOAD_TABLE', value)
  },
  setsaveFilter (store, data) {
    store.commit('UNCHECK_ALL_FILTERS')
    store.commit('SET_SAVE_FILTER', JSON.parse(JSON.stringify(data)))
    // store.commit('CHECK_UNCHECK_FILTER', data)
  },
  setdeleteFilter (store, data) {
    // swal('Bravo!', 'inscription success!', 'success')
    store.commit('SET_DELETE_FILTER', data)
  },
  updateCheckedFilter (store, data) {
    store.commit('SET_UPDATE_CHECKED_FILTER', data)
  },
  deleteCheckedFilter (store) {
    store.commit('SET_DELETE_CHECKED_FILTER')
  },
  setButtonFilter (store, data) {
    store.commit('SET_BUTTON_FILTER', data)
  },
  checkUncheckFilter (store, filter) {
    store.commit('CHECK_UNCHECK_FILTER', filter)
  },
  updateActiveFilter (store, filter) {
    store.commit('UPDATE_ACTIVE_FILTER', filter)
  },
  updateSearchFilter (store, filter) {
    store.commit('UPDATE_SEARCH_FILTER', filter)
  },
  deleteSavedFilter (store, index) {
    if (state.saveFilter[index].checked) {
      store.commit('CHECK_UNCHECK_FILTER', state.saveFilter[index])
    }
    store.commit('DELETE_SAVED_FILTER', index)
  },
  shouldCheckFilter (store, index) {
    store.commit('SHOULD_CHECK_FILTER', index)
  },
  shouldUncheckFilter (store, index) {
    store.commit('SHOULD_UNCHECK_FILTER', index)
  },
  uncheckAllFilters (store) {
    store.commit('UNCHECK_ALL_FILTERS')
  },
  setInitRechercheAo (store, data) {
    store.commit('SET_INIT_RECHERCHE_AO', data)
  }
}

const getters = {
  showFilter: state => state.showFilter,
  saveFilter: state => state.saveFilter,
  checkedFilters: state => state.checkedFilters,
  activeFilter: state => state.activeFilter,
  addButtonFilter: state => state.addButtonFilter,
  searchFilter: state => state.searchFilter,
  chargementTable: state => state.chargementTable,
  initRechercheAo: state => state.initRechercheAo
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/store/modules/appelOffre.js